enum CreatorsFilter {
  All = '',
  Verified = 'Verified',
  Unregistered = 'Unregistered',
}

export default CreatorsFilter;
